import { RefObject, useEffect, useState } from 'react';

import { useIsVisibleHook } from './useIsVisibleHook';

export function useActionOnVisible(
	ref: RefObject<HTMLElement>,
	action?: () => void,
	rootMargin?: string,
): void {
	const [done, setDone] = useState<boolean>(false);

	const isVisible = useIsVisibleHook(ref, 0, false, rootMargin || '80% 0px 0px');

	useEffect(() => {
		if (!done && isVisible) {
			action && action();
			setDone(true);
		}
	}, [isVisible, done]);
}

